<template>
  <div class="kp-flat-card small-shadow dashboard-transactions">
    <h5>Recent transactions</h5>
    <data-tables :data="tableData" layout="table">
      <el-table-column :prop="titles[0].prop" :label="titles[0].label" :key="titles[0].label" :width="titles[0].width"></el-table-column>
      <el-table-column :prop="titles[1].prop" :label="titles[1].label" :key="titles[1].label" :width="titles[1].width"></el-table-column>
      <el-table-column :prop="titles[2].prop" :label="titles[2].label" :key="titles[2].label" :width="titles[2].width"></el-table-column>
      <el-table-column :prop="titles[3].prop" :label="titles[3].label" :key="titles[3].label" :width="titles[3].width" align="center">
        <template slot-scope="scope">
          <img :src="`./img/payments/${scope.row.paymentMethod}.png`" :alt="scope.row.paymentMethod" :style="{maxWidth: '50px'}" />
        </template>
      </el-table-column>
      <el-table-column :prop="titles[4].prop" :label="titles[4].label" :key="titles[4].label" :width="titles[4].width"></el-table-column>
      <el-table-column :prop="titles[5].prop" :label="titles[5].label" :key="titles[5].label" :width="titles[5].width"></el-table-column>
      <el-table-column :prop="titles[6].prop" :label="titles[6].label" :key="titles[6].label" :width="titles[6].width"></el-table-column>
    </data-tables>
  </div>
</template>

<script>
export default {
  name: 'dashboard-transactions',
  data() {
    return {
      tableData: [
        {
          number: '1',
          date: '01.10.2019',
          sender: 'Recreation Centre Repairs & Maintenance',
          paymentMethod: 'visa',
          transactionCode: '14059937',
          invoice_ref: '203046',
          amount: '606.26'
        },
        {
          number: '2',
          date: '02.10.2019',
          sender: 'Council Tax Collection',
          paymentMethod: 'amex',
          transactionCode: '14060494',
          invoice_ref: '203884',
          amount: '880.00'
        },
        {
          number: '3',
          date: '02.10.2019',
          sender: 'Sports & Play Hub Phase 1',
          paymentMethod: 'mastercard',
          transactionCode: '14060430',
          invoice_ref: 'PSI114558',
          amount: '8304.63'
        },
        {
          number: '4',
          date: '01.10.2019',
          sender: 'Recreation Centre Repairs & Maintenance',
          paymentMethod: 'bitcoin',
          transactionCode: '14059937',
          invoice_ref: '203046',
          amount: '606.26'
        },
        {
          number: '5',
          date: '02.10.2019',
          sender: 'Council Tax Collection',
          paymentMethod: 'sepa',
          transactionCode: '14060494',
          invoice_ref: '203884',
          amount: '880.00'
        }
      ],
      titles: [
        {
          prop: 'number',
          label: 'NO.',
          width: '70px'
        },
        {
          prop: 'date',
          label: 'Date',
          width: '120px'
        },
        {
          prop: 'sender',
          label: 'Sender'
        },
        {
          prop: 'paymentMethod',
          label: 'Payment method',
          width: '250px'
        },
        {
          prop: 'transactionCode',
          label: 'Transaction code',
          width: '250px'
        },
        {
          prop: 'invoice_ref',
          label: 'Invoice Ref.',
          width: '180px'
        },
        {
          prop: 'amount',
          label: 'Amount',
          width: '150px'
        }
      ]
    }
  }
}
</script>
